import React from 'react'
import Moment from 'moment'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import FontAwesome from 'react-fontawesome'
import { isMobile } from '../../helpers/window.helper'
import TripPriceHelper from '../../helpers/trip-price.helper'

const StyledLogo = styled.img`
	max-height: 2rem;
`

const StyledGridContainer = styled.div`
	display: grid;
	gap: 1rem;
	align-items: center;
	justify-items: center;
	padding: 1rem;
	border: solid 1px #ccc;

	${({ mobile }) =>
		mobile
			? `
    grid-template-columns: 1fr 1fr 1fr; /* Três colunas */
    grid-template-rows: auto auto auto; /* Três linhas */
  `
			: `
    grid-template-columns: 1fr 1fr 1fr; /* Três colunas */
    grid-template-rows: auto auto; /* Duas linhas */
  `}
`

const StyledCenteredDiv = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`

const StyledDivOriginDestination = styled.div`
	font-weight: bold;
	font-size: 2rem;
	justify-content: ${(props) => props.directionJustify};
`

const OrderSummaryItem = ({ origin, destination, busSeats }) => {
	const { busClass, busCompanyLogoUrl, dataPartida, tripDate } = busSeats[0]

	const dateTrip = dataPartida || tripDate

	const mobile = isMobile()

	return (
		<StyledGridContainer mobile={mobile}>
			{mobile ? (
				<React.Fragment>
					{/* Linha 1 */}
					<div>{origin}</div>
					<div>
						<FontAwesome name="arrow-right" />
					</div>
					<div>{destination}</div>

					{/* Linha 2 */}
					<div>
						<FontAwesome name="clock-o" />{' '}
						{Moment(dateTrip).format('DD/MM/YYYY HH:mm')}
					</div>
					<div></div>
					<div>
						{busSeats.length} poltrona{busSeats.length > 1 ? 's ' : ' '}
						{busSeats.map(({ number, busSeat, bpePointsUsed, fare }, index) => {
							const seatNumber = busSeat || number
							return (
								<span key={index}>
									<span className="orange">[{seatNumber}]</span>
									{bpePointsUsed > 0 && (
										<span style={{ fontSize: '0.85em', marginLeft: '2px' }}>
											{bpePointsUsed.toLocaleString('pt-BR')} pts
											{fare > 0 ? ` + ${fare.$toReais()}` : ''}
										</span>
									)}
									{index < busSeats.length - 1 ? ' ' : ''}
								</span>
							)
						})}
					</div>

					{/* Linha 3 */}
					<div>
						<FontAwesome name="bus" /> {busClass}
					</div>
					<div></div>
					<div>
						{busCompanyLogoUrl && <StyledLogo src={busCompanyLogoUrl} />}
					</div>
				</React.Fragment>
			) : (
				<React.Fragment>
					{/* Linha 1 */}
					<StyledDivOriginDestination directionJustify="start">
						{origin}
					</StyledDivOriginDestination>
					<div>
						<FontAwesome name="arrow-right" />
					</div>
					<StyledDivOriginDestination directionJustify="end">
						{destination}
					</StyledDivOriginDestination>

					{/* Linha 2 */}
					<div>
						<FontAwesome name="clock-o" />{' '}
						{Moment(dateTrip).format('DD/MM/YYYY HH:mm')}
					</div>
					<StyledCenteredDiv>
						<div>
							<FontAwesome name="bus" /> {busClass}
						</div>
						{busCompanyLogoUrl && <StyledLogo src={busCompanyLogoUrl} />}
					</StyledCenteredDiv>
					<div>
						{busSeats.length} poltrona{busSeats.length > 1 ? 's ' : ' '}
						{busSeats.map(({ number, busSeat, bpePointsUsed, fare }, index) => {
							const seatNumber = busSeat || number
							return (
								<span key={index}>
									<span className="orange">[{seatNumber}]</span>
									{bpePointsUsed > 0 && (
										<span style={{ fontSize: '0.85em', marginLeft: '2px' }}>
											{bpePointsUsed.toLocaleString('pt-BR')} pts
											{fare > 0 ? ` + ${fare.$toReais()}` : ''}
										</span>
									)}
									{index < busSeats.length - 1 ? ' ' : ''}
								</span>
							)
						})}
					</div>
				</React.Fragment>
			)}
		</StyledGridContainer>
	)
}

OrderSummaryItem.defaultProps = {
	origin: '',
	busSeats: [
		{
			discount: 0,
			price: 0,
			number: '',
		},
	],
	tripPrice: {
		value: 0,
		points: 0,
		forSubscribers: '',
	},
	destination: '',
	tripGoingSummary: {
		busClass: '',
		departure: new Date(),
		tripDate: new Date(),
		busCompany: '',
	},
}

OrderSummaryItem.propTypes = {
	origin: PropTypes.string,
	busSeats: PropTypes.arrayOf(
		PropTypes.shape({
			discount: PropTypes.number,
			price: PropTypes.number,
			number: PropTypes.number,
		})
	),
	tripPrice: PropTypes.shape({
		value: PropTypes.number,
		points: PropTypes.number,
		forSubscribers: PropTypes.string,
	}),
	destination: PropTypes.string,
	tripGoingSummary: PropTypes.shape({
		busClass: PropTypes.string,
		departure: PropTypes.instanceOf(Date),
		tripDate: PropTypes.instanceOf(Date),
		busCompany: PropTypes.string,
	}),
}

export default OrderSummaryItem
